import { Box, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import _ from 'lodash';
import { useMemo } from 'react';
import GameCard from '../GameCard/GameCard';
import GameCardButton from '../GameCardButton/GameCardButton';
import SpyButton from '../SpyButton/SpyButton';
import { Opponent } from './Opponents.styled';

export default function Opponents() {
    const game = useGame();
    const page = usePage();

    const animate = page.lessonParent === 5;

    const spyButtons = useMemo(() => {
        return page.lessonParent >= 4 && page.lesson !== '4' && page.lesson !== '4.1';
    }, [page.lesson, page.lessonParent]);

    const opponents = useMemo(() => {
        // Get offsets
        const offsets = _.range(4).map(index => {
            const start = -(game.opponents - 1) / 2;
            const increment = Math.min(game.opponents - 1, index);
            return 120 * (start + increment) - 50;
        });

        // Get opponents
        const defaultCardsSide = animate ? 'back' : null;
        return _.range(4).map(index => ({
            cards: game.opponentsCards[index] || [],
            cardsSide: game.opponentsCardsSides[index] || defaultCardsSide,
            offset: offsets[index],
            visible: index < game.opponents,
        }));
    }, [animate, game.opponents, game.opponentsCards, game.opponentsCardsSides]);

    return (
        <Box position="relative">
            {opponents.map((opponent, index) => (
                <Opponent
                    $animate={animate}
                    $index={index}
                    $offset={opponent.offset}
                    $visible={opponent.visible}
                    aria-hidden={!opponent.visible}
                    key={index}
                >
                    <Box alignSelf="center" display="inline-flex" marginBottom={1}>
                        <Box position="relative">
                            <Typography variant="montserrat514">Opponent {index + 1}</Typography>
                            {spyButtons && <SpyButton opponent={index} tabIndex={14 + index} />}
                        </Box>
                    </Box>
                    <Box position="relative">
                        <Box display="flex" gap={1} role="status">
                            <GameCard
                                index={1}
                                name={`opponents-${index}-1`}
                                side={opponent.cardsSide}
                                type={opponent.cards[0]}
                            />
                            <GameCard
                                index={2}
                                name={`opponents-${index}-2`}
                                side={opponent.cardsSide}
                                type={opponent.cards[1]}
                            />
                        </Box>
                        <GameCardButton round="opponents" tabIndex={5} type="showOpponents" />
                    </Box>
                </Opponent>
            ))}
        </Box>
    );
}
